<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Apertura de caja chica
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Finanzas</span>
      <span> /</span>
      <span>Apertura de caja chica</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-body">
      <div class="col dato" style="max-width: 200px;">
        <Strong class="title">Nro. ID</Strong>
        <span class="value">AP-1001</span>
      </div>
      <div class="col dato" style="max-width: 200px;">
        <Strong class="title">Usuario</Strong>
        <span class="value">Juan Pérez</span>
      </div>
      <div class="col dato" style="max-width: 200px;">
        <Strong class="title">Fecha</Strong>
        <span class="value">dd/mm/aaaa</span>
      </div>
      <div class="col dato" style="max-width: 200px;">
        <Strong class="title">Hora</Strong>
        <span class="value">hh:mm</span>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input value="" type="text" id="montoentregar" class="form-control" placeholder="9.000" required #montoentregar />
          <label for="montoentregar">Monto a entregar</label>
        </div>
      </div>
    </div>

  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6;"
  >
    <div></div>
    <button size="sm" mdbBtn type="button" class="btn btn-sm" color="success" mdbWavesEffect>
      Aperturar
    </button>
  </div>
</div>
